import { useEffect, useState } from "react";
import {
    DirectoryWithDocuments,
    fetchDirectory,
} from "../../common/redux/documentsAction";

export const useDirectory = (id: string | null) => {
    const [directory, setDirectory] = useState<DirectoryWithDocuments | null>(
        null
    );
    const [loading, setLoading] = useState(false);

    const getDirectories = async () => {
        if (!id) {
            setDirectory(null);
            return;
        }

        setLoading(true);
        try {
            const data = await fetchDirectory(id);
            setDirectory(data);
        } catch (error) {
            console.error("Error fetching directory:", error);
            setDirectory(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getDirectories();
    }, [id]);

    return { directory, loading, refresh: getDirectories };
};
